export const UPDATE_URL = 'app/EditSessionPage/URL/UPDATE_URL';
export const UPDATE_VARIABLE = 'app/EditSessionPage/URL/UPDATE_VARIABLE';
